import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LoginService } from '~login/services/login.service';
import { LoginActions } from './login.actions';
import { processRestError } from '~shared/error-helper';

export const LoginEffect = createEffect(
    (actions$: Actions = inject(Actions), loginService = inject(LoginService)) => {
        return actions$.pipe(
            ofType(LoginActions.login),
            switchMap(({ email, password }) =>
                loginService.Login(email, password).pipe(
                    map(({ token, reason }) => {
                        if (reason) {
                            return LoginActions.loginFailure({ error: reason });
                        }
                        localStorage.setItem('token', token ?? '');
                        return LoginActions.loginSuccess({ token: token ?? '' });
                    }),
                    catchError((error: unknown) => of(LoginActions.loginFailure({ error: processRestError(error) })))
                )
            )
        );
    },
    { functional: true }
);

export const signInSuccessEffect = createEffect(
    (actions$: Actions = inject(Actions), router: Router = inject(Router)) => {
        return actions$.pipe(
            ofType(LoginActions.loginSuccess),
            switchMap(() => {
                Promise.resolve().then(() => router.navigate(['status']).then());
                return of(EMPTY);
            })
        );
    },
    { functional: true, dispatch: false }
);
export const logoutEffect = createEffect(
    (actions$: Actions = inject(Actions), router: Router = inject(Router)) => {
        return actions$.pipe(
            ofType(LoginActions.logout),
            switchMap(() => {
                localStorage.removeItem('token');
                Promise.resolve().then(() => router.navigate(['login']).then());
                return of(EMPTY);
            })
        );
    },
    { functional: true, dispatch: false }
);
